<template>
  <div>
    <!-- Set payment dialog -->
    <v-dialog
      v-model="show"
      max-width="1000"
    >
      <v-card>
        <v-card-title>Payment for Employee
        <v-spacer></v-spacer>
          <v-switch
            class="mx-3"
            hide-details
            dense
            label="Status"
            v-model="showEmployeeWithStatus"
          ></v-switch>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-1">
            <v-col cols="12" md="3" lg="3">
              <DatePicker
                v-model="paymentAutomaticallyDate"
              />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" lg="4">
              <v-text-field
                v-model="searchForPayment"
                append-icon="mdi-magnify"
                label="Search employee"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            fixed-header
            dense
            class="payment-automatically-form"
            :headers="paymentForEmployeeHeaders"
            :items="filteredEmployeeWithPayment"
            :items-per-page="-1"
            hide-default-footer
            :search="searchForPayment"
            item-key="Employee_ID"
            height="57vh"
          >
            <template v-slot:[`header.Salary`]="{ header }">
                {{ header.text }}<br>
                (total: {{ totalSalary | moneyFilter }})
              </template>
              <template v-slot:[`header.Balance`]="{ header }">
                {{ header.text }}<br>
                (total: {{ totalBalance | moneyFilter }})
              </template>
              <template v-slot:[`header.Payment`]="{ header }">
                {{ header.text }}<br>
                (total: {{ totalPayment | moneyFilter }})
              </template>
            <template v-slot:[`item.Salary`]="{ item }">
              <v-text-field
                v-model="item.Salary"
              ></v-text-field>
            </template>
            <template v-slot:[`item.Balance`]="{ item }">
              {{ item.Balance | moneyFilter }}
            </template>
            <template v-slot:[`item.Payment`]="{ item }">
              <v-text-field
                :class="{
                  'bg-red': item.Payment > 0 && item.Balance != item.Salary,
                  'bg-green': item.Payment < 0,
                }"
                v-model="item.Payment"
              ></v-text-field>
            </template>
            <template v-slot:[`item.Status`]="{ item }">
              <v-switch
                hide-details
                dense
                v-model="item.Status"
              ></v-switch>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn small color="primary" @click.prevent="setStatusForAllEmployee">Set Status to All</v-btn>
          <v-btn small color="primary" @click.prevent="triggerFileInput">Import from xslx</v-btn>
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx, .xls"
            style="display: none;"
            @change="uploadPaymentFile"
          />
          <v-spacer></v-spacer>
          <v-btn small outlined color="primary" @click.prevent="show = false">Cancel</v-btn>
          <v-btn small color="primary" @click.prevent="setPaymentToEmployee">Set Payment</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /Set payment dialog -->
    <!-- Invalid Employees Dialog -->
    <v-dialog v-model="showInvalidEmployees" max-width="600px">
    <v-card>
      <v-card-title>Invalid Employees
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click.prevent="showInvalidEmployees = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="invalidEmployeeHeaders"
          :items="invalidEmployees"
          dense
          hide-default-footer
        ></v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- /Invalid Employees Dialog -->
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'PayrollPaymentAutomatically',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false
    },
    paymentForEmployeeItems: {
      required: false,
      default: []
    }
  },
  data () {
    return {
      searchForPayment: '',
      paymentAutomaticallyDate: formatLocalDate(new Date()),
      employeeWithStatus: false,
      showInvalidEmployees: false,
      invalidEmployees: [],
      paymentForEmployeeHeaders: [
        {
          text: '№',
          value: 'RowNumber',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Employee',
          value: 'Name',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Salary',
          value: 'Salary',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Balance',
          value: 'Balance',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Payment',
          value: 'Payment',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Status',
          value: 'Status',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ],
      invalidEmployeeHeaders: [
        {
          text: '№',
          value: 'RowNumber',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Employee',
          value: 'Employee_FullName',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap',
          divider: true
        },
        {
          text: 'Reason',
          value: 'Reason',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    filteredEmployeeWithPayment () {
      if (!this.showEmployeeWithStatus) {
        return this.paymentForEmployeeItems
      } else {
        return this.paymentForEmployeeItems.filter(item => item.Status)
      }
    },
    showEmployeeWithStatus: {
      get () {
        return this.employeeWithStatus
      },
      set (val) {
        this.employeeWithStatus = val
      }
    },
    totalSalary () {
      let res = 0
      for (let i = 0; i < this.filteredEmployeeWithPayment.length; i++) {
        if (this.filteredEmployeeWithPayment[i].Salary !== 0 && this.filteredEmployeeWithPayment[i].Salary) {
          res += Number(this.filteredEmployeeWithPayment[i].Salary)
        }
      }
      return res
    },
    totalBalance () {
      let res = 0
      for (let i = 0; i < this.filteredEmployeeWithPayment.length; i++) {
        if (this.filteredEmployeeWithPayment[i].Balance !== 0 && this.filteredEmployeeWithPayment[i].Balance) {
          res += Number(this.filteredEmployeeWithPayment[i].Balance)
        }
      }
      return res
    },
    totalPayment () {
      let res = 0
      for (let i = 0; i < this.filteredEmployeeWithPayment.length; i++) {
        if (this.filteredEmployeeWithPayment[i].Payment !== 0 && this.filteredEmployeeWithPayment[i].Payment) {
          res += Number(this.filteredEmployeeWithPayment[i].Payment)
        }
      }
      return res
    }
  },
  mounted () {
  },
  methods: {
    setPaymentToEmployee () {
      const body = {
        EmployeePayment: this.paymentForEmployeeItems.filter(item => item.Status),
        Date: this.paymentAutomaticallyDate
      }
      this.axios.post('/api/payment/automaticpayment', body, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Payment successfully setted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    setStatusForAllEmployee () {
      for (let i = 0; i < this.filteredEmployeeWithPayment.length; i++) {
        this.filteredEmployeeWithPayment[i].Status = true
      }
    },
    triggerFileInput () {
      this.$refs.fileInput.click()
    },
    uploadPaymentFile (event) {
      const file = event.target.files[0]
      if (file) {
        const formData = new FormData()
        formData.append('file', file)
        this.axios.post('/api/payment/upload_payment', formData, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.show = false
          this.$store.dispatch('setSuccess', { successMsg: 'Payment successfully imported' })
          if (res.data.length) {
            this.invalidEmployees = res.data
            this.showInvalidEmployees = true
          }
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }
    }
  },
  filters: {
    moneyFilter (val) {
      return val ? '$' + val.toLocaleString('en', { useGrouping: false, minimumFractionDigits: 2 }) : '$0.00'
    }
  }
}
</script>
<style lang="scss">
  .payment-automatically-form .v-text-field {
    padding-top: 0px;
    margin-top: 4px;
    padding-bottom: 0px;
  }
</style>
